const mr = {
  common: {
    home: "मुख्यपृष्ठ",
    materials: "सामग्री",
    rateCard: "रेट कार्ड",
    cart: "कार्ट",
    myBookings: "माझ्या बुकिंग्स",
    login: "लॉगिन",
    signup: "साइन अप",
    dashboard: "डॅशबोर्ड",
    settings: "सेटिंग्स",
    logout: "लॉगआउट",
    save: "सेव्ह करा",
    loading: "लोड होत आहे...",
  },
  header: {
    brand: "मिस्त्रीबाजार",
  },
  settings: {
    title: "सेटिंग्स",
    subtitle: "आपली प्रोफाइल, भाषा, पत्ता आणि अकाउंट सेटिंग्ज व्यवस्थापित करा.",
    profileSection: "प्रोफाइल",
    languageSection: "भाषा",
    addressSection: "सेव्ह केलेला पत्ता",
    accountSection: "अकाउंट",
    fullName: "पूर्ण नाव",
    phone: "फोन नंबर",
    email: "ईमेल",
    city: "शहर",
    preferredLanguage: "आवडती भाषा",
    flatHouseNo: "फ्लॅट नं / घर नं",
    streetArea: "रस्ता / परिसर",
    state: "राज्य",
    country: "देश",
    pincode: "पिनकोड",
    role: "भूमिका",
    uniqueId: "युनिक आयडी",
    saveProfile: "प्रोफाइल सेव्ह करा",
    saveAddress: "पत्ता सेव्ह करा",
    accountDetails: "अकाउंट तपशील",
  },
  home: {
    heroTitle: "मिस्त्रीबाजार",
    heroText:
      "सेवा बुक करा, सामग्री खरेदी करा, आपले घर बांधा, आणि स्थानिक समन्वय, लपलेले खर्च आणि अनिश्चित वेळापत्रकाची डोकेदुखी कमी करा.",
    buyMaterials: "सामग्री खरेदी करा",
    buildYourHouse: "आपले घर बांधा",
    exploreMembership: "मेंबरशिप पहा",
    services: "सेवा",
    about: "आमच्याबद्दल",
    contactUs: "संपर्क करा",
    privacyPolicy: "गोपनीयता धोरण",
    terms: "अटी व शर्ती",
  },
};

export default mr;